import {gsap} from "gsap";

const Search = {
	delay: 300,
	delayTimer: null,

	init() {
		this.el = $('[module="Search"]');
		if(!this.el.length) return;

		this.searchBar = this.el.filter('.searchBar');
		this.searchButton = $('[component="Header"] .button.search');
		this.closeButton = this.searchBar.find('.button.close');
		this.results = this.searchBar.find('[container="results"] .holder');
		this.moreButton = this.results.find('.button');
		this.input = this.searchBar.find('input.search');
		this.bind();
	},

	bind() {
		this.input.on('keyup', (e) => this.typing(e));

		this.searchButton.click((evt) => {
			evt.preventDefault();
			this.searchBar.addClass('show');
			this.input.focus();
		});

		this.closeButton.click((evt)=>{
			this.reset();
		});

		this.moreButton.click((evt)=>{
			this.searchBar.find('form').submit();
		});

		$(document).keyup((e)=> {
			if (e.key === "Escape") {
				this.reset();
			}
		});
	},

	typing(e) {
		clearTimeout(this.delayTimer);
		this.delayTimer = setTimeout(() => this.search(e), this.delay);
	},

	search(e) {
		const value = e.target.value;

		$.ajax({
			method: "GET",
			dataType: '',
			url: "/modules/search/views/search.bar.async.php",
			data: {
				s: value
			},
			success: (response) => {
				this.showResults(response);
			},
			error: function(data, textStatus, jqXHR) {
				console.log(data, textStatus, jqXHR);
			}
		});
	},

	showResults(response){
		if(response.length) this.moreButton.addClass('visible');
		else this.moreButton.removeClass('visible');
		this.results.find('.inner').html(response);
		gsap.to(this.results.parent('[block]'), {height:this.results.outerHeight()});
	},

	reset(){
		this.input.val('').trigger('keyup');
		this.searchBar.removeClass('show');
	}
}

export default Search;